/* eslint-disable @typescript-eslint/naming-convention */
import { ENDPOINT } from "@payment-client/apis/Order";
import { makeDownstreamApiCall } from "@swiggy-private/checkout-core";
import { ApiResponse } from "@swiggy-private/payment-core";
import { ConfirmOrderParams } from "@payment-client/apis/Order";
import { OrderApiData, GiftingOrderResponseData } from "@swiggy-private/payment-types";
import { transformGiftingOrderResponse } from "../order-transformer";

export const publicGiftingConfirmOrder = async (
    apiHost: string,
    params: ConfirmOrderParams,
): Promise<ApiResponse<OrderApiData>> => {
    if (params == null) {
        throw new Error("Confirm order data is required to make gifting confirm order");
    }

    const backendResponse = await makeDownstreamApiCall(
        {
            apiHost,
            endpoint: ENDPOINT.GIFTING_CONFIRM_ORDER,
            bodyParams: params,
            options: { method: "POST" },
        },
        true,
    );

    const { rawResponse, data, ...extraFields } = backendResponse;
    const buildResponse = {
        ...extraFields,
        data,
    } as ApiResponse<GiftingOrderResponseData, unknown>;
    const transformedResponse = transformGiftingOrderResponse(buildResponse, rawResponse);

    // expected response in SDK - { statusCode, data, rawResponse, pendingPaymentParams } = response;
    return transformedResponse;
};
